import React from 'react';
import memoize from 'lodash/memoize';

interface Props {
  text: string | undefined | null;
  className?: string;
  handNote?: string | null;
  supportTicketNumber?: string | null;
}

/** Helper to memoize strings that are used in table cells and title props */
export const getTextAndTitle = memoize((text: string | undefined | null): string => {
  return text || 'Not available';
});

/** All-in-one create a <td> with matching title and text */
const SimpleTD = ({ text, className, handNote, supportTicketNumber }: Props) => {
  return (
    <td className={className} title={getTextAndTitle(text)}>
      {getTextAndTitle(text)}
      {handNote ? (
        <div className="n-300" style={{ whiteSpace: 'normal' }}>
          Note: {handNote}
        </div>
      ) : null}{' '}
      {supportTicketNumber ? <div className="n-300">Support Ticket Number: {supportTicketNumber}</div> : null}
    </td>
  );
};

export default SimpleTD;
